<template>
  <div class="libox">
    <a class="topColumnname" :href="'/column?columnId='+list.COLUMN_ID" target="_blank">
      {{ list.COLUMN_NAME }}
    </a>
    <a class="imgbox" :href="'/Detail?contentId='+list.CONTENT_ID" target="_blank">
      <img v-if="list.CONTENT_PHOTO_SMALL" :src="list.CONTENT_PHOTO_SMALL" alt="">
      <img v-else :src="defaultimg[randomimg]" alt="">
    </a>
    <p class="content" @click="goDetail(list.CONTENT_ID)">
      <span class="titlename">{{ list.CONTENT_TITLE }}</span>
      <span class="hot_time">{{ list.CONTENT_ISSUE_DATE|changeTime }}</span>
      <span class="el-icon-view viewNumber"> {{ list.CONTENT_READING_SIZE|changenum }}</span>
      <span class="viewNumber viewStar"><svg-icon icon-class="pinlun" />   {{ list.CONTENT_SPEAK_SIZE|changenum }}</span>
    </p>
    <div v-if="list.TEMPLATE_ID==='VIDEO'" class="vdoIMG" @click="goDetail(list.CONTENT_ID)" />
    <div v-if="list.TEMPLATE_ID==='PHOTO'" class="tuji">
      {{ list.CONTENT_PHOTO_SIZE }}图
    </div>
  </div>
</template>
<script>
// ///首页列表模板上中下形式
export default {
  name: 'ListTemolate1',
  props: ['list'],
  data() {
    return {
      randomimg: Math.floor(Math.random() * 5),
      defaultimg: [
        require('@/static/newsdefault1.jpg'),
        require('@/static/newsdefault2.jpg'),
        require('@/static/newsdefault3.jpg'),
        require('@/static/newsdefault4.jpg'),
        require('@/static/newsdefault5.jpg')
      ],
      noIMG: require('@/static/home_noimg.png')
    }
  },
  methods: {
    gocolumn: function(contentId, name) {
      // this.$router.push({ name: 'column', params: { columnName: contentId }})
      window.location.href = '/column/?columnId=' + contentId
    },
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .libox{
        display: inline-block;
        width: 100%;
        font-size: 0;
       position: relative;
        .topColumnname{
          text-align: center;
            position: absolute;
            top:10px;
            left: 10px;
          padding: 0 5px;
            background-color:rgba(51,51,51,.5);
            font-size: 12px;
            color: #ffffff;
            height: 18px;
            line-height: 18px;
            border-radius: 3px;
            cursor: pointer;
            &:hover{
                background-color: rgba(237,64,64,.5);
            }
        }
        .imgbox{
            display: inline-block;
            width: 275px;
            height: 183px;
            font-size: 0;
          cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .content{
          background-color: #fff;
            width: 263px;
            height: 93px;
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            -moz-box-shadow:1px 1px 3px #f3f3f3;
            -webkit-box-shadow:1px 1px 3px #f3f3f3;
            box-shadow:1px 1px 3px #f3f3f3;
            text-align: left;
            padding-left: 10px;
            .titlename{
                color: #333333;
                font-size: 14px;
                font-weight:500;
                display: inline-block;
                padding-top: 8px;
                height:55px;
                line-height: 25px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .hot_time{
                display: inline-block;
                width: 155px;
                height: 25px;
                font-size: 12px;
                color: #b2b2b2;
            }
            .viewNumber{
                display: inline-block;
                height: 25px;
                width: 50px;
                font-size: 12px;
                color: #b2b2b2;
              text-align: right;
              svg{
                vertical-align:middle;
              }
            }
            .viewStar{
                width: 50px;
            }
        }
    }
    .vdoIMG{
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 3px solid rgba(249,245,246,.5);
      position: absolute;
      top: 66.5px;
      left: 112.5px;
      cursor: pointer;
    }
    .vdoIMG::after{
      content: '';
      display: block;
      position: absolute;
      top: 13px;
      left: 15px;
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom:  12px solid transparent;
      border-left:20px solid rgba(247,247,247,.5);
    }
  .tuji{
    position: absolute;
    width: 36px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    top: 150px;
    background-color:rgba(51,51,51,.5);
    border-radius: 5px;
    right: 10px;
    &:hover{
      background-color: rgba(237,64,64,.5);
    }
  }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .viewStar{
      display: none;
    }
    .topColumnname{
    display: none;
  }
    .libox{
      overflow: hidden;
      background-color: #fff;
      font-size: 0;
      .imgbox{
        display: inline-block;
        float: right;
        height: 90px;
        width: 30%;
        overflow: hidden;
        img{
          width: 100%;
          height: auto;
        }
      }
      .content{
        display: inline-block;
        float: left;
        width: 70%;
        height: 90px;
        padding-left: 0px;
        border: none;
        box-shadow:none;
        .titlename{
          padding-top: 0;
          font-weight: 600;
        }
      }
    }
    .vdoIMG{
      left: calc(70% + 20px);
      top: 5px;
    }
    .libox .content .hot_time{
      width: 110px;
    }
  }
</style>
